import React, {} from 'react';
import {Input} from 'antd';
import { useT } from 'hooks/Locale/useT';
import debounce from "lodash.debounce";

interface SearchInterface {
    setSearchString: React.Dispatch<React.SetStateAction<string>>
    setReload?: React.Dispatch<React.SetStateAction<boolean>>
}

const Search: React.FC<SearchInterface> = ({setSearchString, setReload}) => {
    const t = useT();
    const {Search} = Input;

    const loadOptionsTimeOut = debounce(function (searchValue: string) {
        const searchString = searchValue.trim();

        if (searchValue.length === 0 || searchString.length >= 3) {
            setSearchString(searchString);

            if (setReload) {
                setReload(true);
            }
        }
    }, 800);

    return (
        <Search
            allowClear
            placeholder={t('general.search')}
            onChange={value => loadOptionsTimeOut(value.target.value)}
            onSearch={value => {
                setSearchString(value.trim());

                if (setReload) {
                    setReload(true);
                }
            }}
        />
    )
};

export default Search;